/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_appsync_graphqlEndpoint": "https://dy4uerxxtjffxoqk3o3owbvecu.appsync-api.us-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-lhbmhornpbdwhlpj2gmxjqocqa",
    "aws_cognito_identity_pool_id": "us-west-1:d9536a3f-7332-45ea-9584-6bd996749585",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_lUl5dgSMH",
    "aws_user_pools_web_client_id": "537e4a2ja6b5ni3g2tlstu9nm3",
    "oauth": {
        "domain": "midisandbox7970c8ae-7970c8ae-dev.auth.us-west-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://www.midisandbox.com/login/",
        "redirectSignOut": "https://www.midisandbox.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "sandboxstorage113445-dev",
    "aws_user_files_s3_bucket_region": "us-west-1"
};


export default awsmobile;
